var render = function render(){var _vm=this,_c=_vm._self._c;return _c('method-config-component',{attrs:{"search-params":_vm.searchParams,"config-name-list":_vm.configNameList}})
}
var staticRenderFns = []

export { render, staticRenderFns }